import React from 'react';
import ASEvent from './Events';
import {
  Legend,
  SeriesCollectionDirective,
  ChartComponent,
  ColumnSeries,
  Category,
  SeriesDirective,
  Tooltip,
  DataLabel,
  DateTime,
  SplineAreaSeries,
} from '@syncfusion/ej2-react-charts';
import {
  DashboardLayoutComponent,
  PanelDirective,
  PanelsDirective,
} from '@syncfusion/ej2-react-layouts';
import { ThemeContext } from '../../context/theme.context';
import {
  RichTextEditorComponent,
  Toolbar,
  Inject,
  Image,
  Link,
  HtmlEditor,
  Count,
  QuickToolbar,
  Table,
  FileManager,
} from '@syncfusion/ej2-react-richtexteditor';
import { FiChevronDown } from 'react-icons/fi';
export let expensedata = [
  {
    UniqueId: 'T100003',
    DateTime: new Date(1488359820000),
    Category: 'Food',
    PaymentMode: 'Cash',
    TransactionType: 'Expense',
    Description: 'Confederate cush',
    Amount: '900',
    MonthShort: 'Mar',
    MonthFull: 'March, 2017',
    FormattedDate: '03/01/2017 08:53 PM',
    Device: 'Tablet',
  },
  {
    UniqueId: 'T100004',
    DateTime: new Date(1491038220000),
    Category: 'Transportation',
    PaymentMode: 'Credit Card',
    TransactionType: 'Expense',
    Description: 'Public and other transportation',
    Amount: '1200',
    MonthShort: 'Apr',
    MonthFull: 'April, 2017',
    FormattedDate: '04/01/2017 10:44 AM',
    Device: 'Desktop',
  },
  {
    UniqueId: 'T100005',
    DateTime: new Date(1493630220000),
    Category: 'Transportation',
    PaymentMode: 'Cash',
    TransactionType: 'Expense',
    Description: 'Public and other transportation',
    Amount: '600',
    MonthShort: 'May',
    MonthFull: 'May, 2017',
    FormattedDate: '05/01/2017 03:25 PM',
    Device: 'Mobile',
  },
];
export let data1 = [
  { x: new Date(2002, 0, 1), y: 2.2 },
  { x: new Date(2003, 0, 1), y: 3.4 },
  { x: new Date(2004, 0, 1), y: 2.8 },
  { x: new Date(2005, 0, 1), y: 1.6 },
  { x: new Date(2006, 0, 1), y: 2.3 },
  { x: new Date(2007, 0, 1), y: 2.5 },
  { x: new Date(2008, 0, 1), y: 2.9 },
  { x: new Date(2009, 0, 1), y: 3.8 },
  { x: new Date(2010, 0, 1), y: 1.4 },
  { x: new Date(2011, 0, 1), y: 3.1 },
];
export let data2 = [
  { x: new Date(2002, 0, 1), y: 2 },
  { x: new Date(2003, 0, 1), y: 1.7 },
  { x: new Date(2004, 0, 1), y: 1.8 },
  { x: new Date(2005, 0, 1), y: 2.1 },
  { x: new Date(2006, 0, 1), y: 2.3 },
  { x: new Date(2007, 0, 1), y: 1.7 },
  { x: new Date(2008, 0, 1), y: 1.5 },
  { x: new Date(2009, 0, 1), y: 2.8 },
  { x: new Date(2010, 0, 1), y: 1.5 },
  { x: new Date(2011, 0, 1), y: 2.3 },
];

interface IState {}
interface IProps {}
export default class Dashboard extends React.Component<IProps, IState> {
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  private rteObj: RichTextEditorComponent;
  private quickToolbarSettings = {
    table: [
      'TableHeader',
      'TableRows',
      'TableColumns',
      'TableCell',
      '-',
      'BackgroundColor',
      'TableRemove',
      'TableCellVerticalAlign',
      'Styles',
    ],
  };
  private toolbarSettings = {
    items: [
      'Bold',
      'Italic',
      'Underline',
      'StrikeThrough',
      'FontName',
      'FontSize',
      'FontColor',
      'BackgroundColor',
      'LowerCase',
      'UpperCase',
      '|',
      'Formats',
      'Alignments',
      'NumberFormatList',
      'BulletFormatList',
      'Outdent',
      'Indent',
      'SuperScript',
      'SubScript',
      '|',
      'CreateTable',
      'CreateLink',
      'Image',
      'FileManager',
      '|',
      'ClearFormat',
      'Print',
      'SourceCode',
      'FullScreen',
      '|',
      'Undo',
      'Redo',
    ],
  };
  private hostUrl = 'https://ej2-aspcore-service.azurewebsites.net/';
  private fileManagerSettings = {
    enable: true,
    path: '/Pictures/Food',
    ajaxSettings: {
      url: this.hostUrl + 'api/FileManager/FileOperations',
      getImageUrl: this.hostUrl + 'api/FileManager/GetImage',
      uploadUrl: this.hostUrl + 'api/FileManager/Upload',
      downloadUrl: this.hostUrl + 'api/FileManager/Download',
    },
  };
  private dlc:DashboardLayoutComponent
  constructor(prop: IProps) {
    super(prop);
    this.rteObj = new RichTextEditorComponent(prop);
    this.dlc=new DashboardLayoutComponent({});
  }
  componentDidMount(){
  }
  textRichComponent() {
    return (
      <div style={{ height: '100%' }}>
        <RichTextEditorComponent
          id='toolsRTE'
          ref={(richtexteditor) => {
            this.rteObj = richtexteditor as RichTextEditorComponent;
          }}
          showCharCount={true}
          maxLength={2000}
          toolbarSettings={this.toolbarSettings}
          fileManagerSettings={this.fileManagerSettings}
          quickToolbarSettings={this.quickToolbarSettings}
          height={'52.6vh'}
        >
          <div>
            <p>
              The Rich Text Editor is a WYSIWYG ("what you see is what you get")
              editor useful to create and edit content, and return the valid{' '}
              <a href='https://ej2.syncfusion.com/home/' target='_blank'>
                HTML markup
              </a>{' '}
              or{' '}
              <a href='https://ej2.syncfusion.com/home/' target='_blank'>
                markdown
              </a>{' '}
              of the content
            </p>{' '}
            <p>
              <b>Toolbar</b>
            </p>
            <ol>
              <li>
                {' '}
                <p>
                  The Toolbar contains commands to align the text, insert a
                  link, insert an image, insert list, undo/redo operations, HTML
                  view, etc{' '}
                </p>
              </li>
              <li>
                <p>The Toolbar is fully customizable </p>
              </li>
            </ol>{' '}
            <p>
              <b>Links</b>
            </p>
            <ol>
              <li>
                <p>You can insert a hyperlink with its corresponding dialog </p>
              </li>
              <li>
                <p>Attach a hyperlink to the displayed text. </p>
              </li>
              <li>
                <p>Customize the quick toolbar based on the hyperlink </p>{' '}
              </li>
            </ol>
            <p>
              <b>Image.</b>
            </p>
            <ol>
              <li>
                <p>
                  Allows you to insert images from an online source as well as
                  the local computer{' '}
                </p>{' '}
              </li>
              <li>
                <p>You can upload an image</p>
              </li>
              <li>
                <p>
                  Provides an option to customize the quick toolbar for an image{' '}
                </p>
              </li>
            </ol>
            <img
              alt='Logo'
              src='https://ej2.syncfusion.com/react/demos/src/rich-text-editor/images/RTEImage-Feather.png'
              style={{ width: '300px' }}
            />
          </div>
          <Inject
            services={[
              Toolbar,
              Image,
              Link,
              HtmlEditor,
              Count,
              QuickToolbar,
              Table,
              FileManager,
            ]}
          />
        </RichTextEditorComponent>
      </div>
    );
  }
  visitorsChart() {
    return (
      <div style={{ height: '100%' }}>
        <ChartComponent
          id='visitorsChart'
          style={{ textAlign: 'center' }}
          legendSettings={{ visible: false }}
          height={'82%'}
          background={this.context.isDarkMode ? '#15202B' : 'white'}
          primaryXAxis={{
            valueType: 'DateTime',
            labelFormat: 'y',
            majorGridLines: { width: 0 },
            intervalType: 'Years',
            edgeLabelPlacement: 'Shift',
          }}
          primaryYAxis={{
            labelFormat: '{value}%',
            lineStyle: { width: 0 },
            maximum: 4,
            interval: 1,
            majorTickLines: { width: 0 },
            minorTickLines: { width: 0 },
          }}
        >
          <Inject services={[SplineAreaSeries, DateTime, Legend]} />
          <SeriesCollectionDirective>
            <SeriesDirective
              dataSource={data1}
              xName='x'
              yName='y'
              name='Jan'
              opacity={0.5}
              type='SplineArea'
              width={2}
              fill='rgb(239, 183, 202)'
            ></SeriesDirective>
            <SeriesDirective
              dataSource={data2}
              xName='x'
              yName='y'
              name='Feb'
              opacity={0.5}
              type='SplineArea'
              width={2}
              fill='rgb(14, 64, 152, .6)'
            ></SeriesDirective>
          </SeriesCollectionDirective>
        </ChartComponent>
      </div>
    );
  }
  pieChart() {
    return <div style={{ height: '100%', width: '100%' }}></div>;
  }
  colChart() {
    return (
      <div style={{ height: '100vh', display: 'inline-block' }}>
        <ChartComponent
          id='colChart'
          style={{ textAlign: 'center' }}
          legendSettings={{ visible: false }}
          primaryXAxis={{
            valueType: 'Category',
            interval: 1,
            majorGridLines: { width: 0 },
          }}
          primaryYAxis={{
            majorGridLines: { width: 0 },
            majorTickLines: { width: 0 },
            lineStyle: { width: 0 },
            labelStyle: { color: 'transparent' },
          }}
          chartArea={{ border: { width: 0 } }}
          tooltip={{ enable: true }}
          background={this.context.isDarkMode ? '#15202B' : 'white'}
        >
          <Inject
            services={[ColumnSeries, Legend, Tooltip, Category, DataLabel]}
          />
          <SeriesCollectionDirective>
            <SeriesDirective
              dataSource={[
                { x: 'Jan', y: 46 },
                { x: 'Feb', y: 27 },
                { x: 'Mar', y: 26 },
              ]}
              xName='x'
              yName='y'
              name='Desktop'
              type='Column'
              marker={{
                dataLabel: {
                  visible: false,
                  position: 'Top',
                  font: { fontWeight: '600', color: '#ffffff' },
                },
              }}
            ></SeriesDirective>
            <SeriesDirective
              dataSource={[
                { x: 'Jan', y: 37 },
                { x: 'Feb', y: 23 },
                { x: 'Mar', y: 18 },
              ]}
              xName='x'
              yName='y'
              name='Mobile'
              type='Column'
              marker={{
                dataLabel: {
                  visible: false,
                  position: 'Top',
                  font: { fontWeight: '600', color: '#ffffff' },
                },
              }}
              fill='#e56691'
            ></SeriesDirective>
            <SeriesDirective
              dataSource={[
                { x: 'Jan', y: 38 },
                { x: 'Feb', y: 17 },
                { x: 'Mar', y: 26 },
              ]}
              xName='x'
              yName='y'
              name='Tablet'
              type='Column'
              marker={{
                dataLabel: {
                  visible: false,
                  position: 'Top',
                  font: { fontWeight: '600', color: '#ffffff' },
                },
              }}
            ></SeriesDirective>
          </SeriesCollectionDirective>
        </ChartComponent>
      </div>
    );
  }
  collapseListener=()=>{
    $('.dashboard').toggleClass('show-content-event');
    $('#rotate-icon-dashboard').toggleClass('rotateIcon-event');
    this.dlc.refresh()
  }
  render(): React.ReactNode {
    return (
      <div className='sidebar-content dashboardOverFlow'>
        <ASEvent />
        {/* <div className='collapse-parent-div '>
          <div className='collapse-sub-flex collapse-dashboard' onClick={this.collapseListener.bind(this)}>
            <div className='collapse-icon-div-dashboard collapse-flex'>
              <FiChevronDown id='rotate-icon-dashboard' size={17} />
            </div>
          </div>
          <div className='dashboard show-content-event'>
            <div>
              <DashboardLayoutComponent
                id='analytic_dashboard'
                ref={(DLC:DashboardLayoutComponent)=>this.dlc=DLC}
                cellAspectRatio={100 / 85}
                cellSpacing={[5, 5]}
                columns={6}
                allowDragging={false}
              >
                <PanelsDirective>
                  <PanelDirective
                    sizeX={2}
                    sizeY={2}
                    row={1}
                    col={0}
                    content={this.textRichComponent.bind(this)}
                    header='<div>Text Editor</div>'
                  ></PanelDirective>
                  <PanelDirective
                    sizeX={2}
                    sizeY={2}
                    row={1}
                    col={2}
                    content={this.fileManager.bind(this)}
                    header='<div>File Manager</div>'
                  ></PanelDirective>
                  <PanelDirective
                    sizeX={2}
                    sizeY={2}
                    row={1}
                    col={4}
                    content={this.colChart.bind(this)}
                    header='<div style={{backgroundColor:"black"}}>Visitors by Type</div>'
                  ></PanelDirective>
                  <PanelDirective
                    sizeX={2}
                    sizeY={2}
                    row={3}
                    col={0}
                    header='<div>Useage Statistics</div>'
                  ></PanelDirective>
                  <PanelDirective
                    sizeX={4}
                    sizeY={2}
                    row={3}
                    col={2}
                    content={this.visitorsChart.bind(this)}
                    header='<div>Traffic History</div>'
                  ></PanelDirective>
                </PanelsDirective>
              </DashboardLayoutComponent>
            </div>
          </div>
        </div> */}
      </div>
    );
  }
}
